/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
import * as marietta from '../..';
import { Point } from '../../core';
import { MasterItemCollection } from '../collection';
import {
  BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE, FREETEXT_ITEMCODE, ITEM_MODE_KEY, MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM, MIN_ITEM_PLAN_SIZE_MM,
  OVERLAP_HITTEST_RADIUS_MM, SITE_INPUT_MODE,
} from '../Constants';
import { SVGSprite } from '../flash/display';
import { Master, Stage } from '../model';
import { Fitting } from './index';
import PinPicture from './PinPicture';

// 2D の描画サイズの下限(px)。正のサイズが 0px に丸まると見えず、つかめなくなるため
const MIN_DRAW_SIZE_PIX: number = 1;

export default class MonicaObject {
    // viewObj;
    itemInfo: marietta.webcad.collection.ItemInfoCollection;

    localDragPoint: marietta.core.Point;

    originalWidth: number = 1;

    originalHeight: number = 1;

    isFollowingMouse: boolean;

    previousPlace: marietta.core.Point;

    wallList: marietta.webcad.item.parts.Wall[] = [];

    // マウス移動でアイテム移動を行うか否か
    moveOnMouseMove: boolean;

    private dragInitX: number;

    private dragInitY: number;

    public spt: SVGSprite;

    protected moveMouseEvent: MouseEvent;

    wallPreviousPlace: marietta.core.Point;

    previousRotation: number;

    previousSnapWall: marietta.webcad.item.parts.Wall = null;

    private longPressTime: number | null = null;
    private isLongPress: boolean = false; // 長押し処理か

    private _clickTimeout;

    /**
     * コンストラクタ
     * @param ItemInfoCollection
     */
    constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
      this.itemInfo = _itemInfo;
      this.itemInfo.guid = _itemInfo.guid;

      // マウス吸着中
      this.isFollowingMouse = false;

      // イメージの作成
      this.createImage();

      // アイテムのサイズ変更
      if (this.itemInfo.use_mm) {
        this.changeSizeForInit(this.itemInfo.widthmm, this.itemInfo.heightmm, false);
      } else {
        this.changeSizeForInit(this.itemInfo.width, this.itemInfo.height, true);
      }

      const viewObj = this.spt.element;
      viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}`);

      // 座標が指定されていなければ、そのままくっつく
      if (this.itemInfo.x === undefined || this.itemInfo.x === null) {
        this.startFollowMouse();
      } else {
        // 基本アクション
        this.initMe();
      }
    }

    /**
     * リドロー
     */
    // eslint-disable-next-line class-methods-use-this
    reCreateImage() { }

    /**
     * ビューの作成
     */
    createImage(): void {
      const viewObj: SVGElement = Master.getItemSvg(this.itemInfo.id);
      if (this.itemInfo.id.substring(0, 3) === 'bem') {
        viewObj.getElementsByTagName('rect')[0].setAttribute('vector-effect', 'non-scaling-stroke');
      }
      this.spt = new SVGSprite(viewObj);
    }

    /**
     * 縮尺の初期化処理
     */
    initMeasurement() {
      if (this.itemInfo.width !== undefined) return;

      // 元サイズの保持
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1 / root.scaleX;
      const rect = this.spt.getBoundingClientRect();
      this.originalWidth = rect.width * sc;
      this.originalHeight = rect.height * sc;

      if ((this.itemInfo.x) !== undefined) {
        // XYの位置を復元
        this.updateTransforms();

        // カレントの設定
        marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
      }
    }

    /**
     * 初期化
     */
    initMe = () => {
      // スマホの場合は、敷地・部屋・階段・建具は編集（選択できない）
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile) {
        switch (true) {
          case this instanceof marietta.webcad.item.Stair:
          case this instanceof marietta.webcad.item.Room:
          case this instanceof marietta.webcad.item.Site:
          case this instanceof marietta.webcad.item.Fitting:
            return;
          default: break;
        }
      }

      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.spt.element.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        this.spt.element.addEventListener('mousedown', this.onMouseDownMe);

        this.spt.element.addEventListener('contextmenu', (event) => {
          event.preventDefault();

          //重複リスト
          marietta.webcad.WebCADGlobal.overlapItemList.showList();
        });
      }
    }


    /**
     * ダブルクリックするアイテムか否か
     * @returns
     */
    private isDoubleClick(): boolean {
      return (this instanceof marietta.webcad.item.PinPicture && marietta.webcad.WebCADGlobal.itemManager.currentItem == this)
          || (this instanceof marietta.webcad.item.PinPanorama && marietta.webcad.WebCADGlobal.itemManager.currentItem == this);
    }

    /**
     * マウスダウンされた
     * @param MouseEvent
     */
    onMouseDownMe = (e: MouseEvent & TouchEvent) => {
      if (this instanceof marietta.webcad.item.PinText) {
        if ((e.target as HTMLElement).closest('foreignObject')) {
          return;
        }
      }

      // ダブルクリックでピン編集ダイアログ or パノラマビューワー
      if (this.isDoubleClick()) {
        if (this._clickTimeout) {
          this._clickTimeout = null;
          if (this instanceof marietta.webcad.item.PinPicture) {
            const param = {
              parentObj: this,
              view_mode: false,
            };
            marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinPictureInfoDialog, true, true, false, true, param);
          } else {
            this.panoramaView();
            return;
          }
        } else {
          this._clickTimeout = setTimeout(() => {
            console.log('Single-click action');
            this._clickTimeout = null; // Reset the timeout
          }, 300);
        }
      }

      this.isLongPress = false;
      marietta.webcad.WebCADGlobal.overlapItemList.hideList();
      if (e && e.target) {
        if ((e.target as HTMLElement).classList.contains('pinLink')) {
          return;
        } else if ((e.target as HTMLElement).parentElement.classList.contains('pinLink')) {
          return;
        }
      }
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode()) {
        return;
      }
      if (this instanceof marietta.webcad.item.Site && this.inputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup) {
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.onMouseDownMe(e as MouseEvent & TouchEvent);
      }
      if ((e.target as HTMLElement).id !== 'guideText') {
        if (document.querySelector('.wallGuideTextbox')) {
          document.querySelectorAll('.wallGuideTextbox').forEach((element) => {
            element.remove();
          });
        }
        if (document.querySelector('.wallGuideText')) {
          document.querySelectorAll('.wallGuideText').forEach((element: SVGElement) => {
            // eslint-disable-next-line no-param-reassign
            element.style.display = 'block';
          });
        }
      }
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        if ((<TouchEvent>e).touches.length > 1) {
          return;
        }

        Stage.refreshStageMouse(<any>e);
      }
      // 参照モードなら無効
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === '2') return;
      if (this instanceof marietta.webcad.item.Shitae) return;
      if (this instanceof marietta.webcad.item.Site && !marietta.webcad.WebCADGlobal.layerGroup.siteEnabled) {
        return;
      }

      // カレントアイテムが自分以外で初期配置時は無視
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem && marietta.webcad.WebCADGlobal.itemManager.currentItem.isFollowingMouse) {
        // ドラッグを停止する
        if (this instanceof marietta.webcad.item.Stair) marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
        marietta.webcad.WebCADGlobal.itemManager.currentItem.stopFollowMouse(e);
        marietta.webcad.WebCADGlobal.itemManager.currentItem.onMouseDownMe(e);
        return;
      }
      // カレントアイテムが自分以外で、マウス座標がカレントアイテムに重なっている場合は、
      // 自分ではなくカレントアイテム側の処理に委譲する(重なったアイテムのmousedownによる選択の奪い合いを防ぐ)
      // Shift/Ctrl/タップ複数選択モードでは、グループへの追加操作を優先するため対象外とする
      if (
        marietta.webcad.WebCADGlobal.itemManager.currentItem
        && marietta.webcad.WebCADGlobal.itemManager.currentItem !== this
        && !(e.shiftKey || e.ctrlKey || marietta.webcad.WebCADGlobal.webcad2Dmanager.isTapMultiSelectMode)
      ) {
        const currentItem: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.itemManager.currentItem;
        const mouseP: Point = new Point(
          marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX,
          marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY,
        );
        const guardRadius: number = marietta.webcad.util.WebCADUtil.convertMMToPix(OVERLAP_HITTEST_RADIUS_MM);
        if (marietta.webcad.WebCADGlobal.overlapItemList.isPointOverlappingItem(currentItem, mouseP, guardRadius)) {
          currentItem.onMouseDownMe(e);
          return;
        }
      }
      // カレントグループがあり、マウスのドラッグ中であれば無視
      if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isFollowingMouse) {
        // ドラッグを停止する
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.stopFollowMouse(e);
        return;
      }
      // 長押し
      this.startLongPress();
      // アイテムが選択できるかどうかを確認。 現在開いているメニューによって異なります (iPad)
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        if (!marietta.webcad.WebCADGlobal.itemManager.isCapableToSelect(this)) return;
      }

      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;

      // 選択モードのときは、バブリングさせない
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
        e.stopPropagation();
      }

      // 屋根は複数選択しない
      // タブレット等の複数選択モードでは、キー修飾なしのタップでも複数選択（追加）できるようにする
      if ((e.shiftKey || e.ctrlKey || marietta.webcad.WebCADGlobal.webcad2Dmanager.isTapMultiSelectMode) && !(this instanceof marietta.webcad.item.Roof)) {
        // タップでのトグル選択時は、長押し（重なりリスト表示）を発動させない
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isTapMultiSelectMode) this.stopLongPress(false);
        const prevItem: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.itemManager.currentItem;
        // 壁とアイテムは同一グループに混在できないため、壁だけが選択されている状態から
        // アイテムを複数選択しようとした場合は、壁の選択を解除してアイテムの単独選択に切り替える
        const hasItemSelection: boolean = Boolean(marietta.webcad.WebCADGlobal.itemManager.currentItem) || Boolean(marietta.webcad.WebCADGlobal.itemManager.currentItemGroup);
        const hasWallSelection: boolean = Boolean(marietta.webcad.WebCADGlobal.itemManager.currentWall) || Boolean(marietta.webcad.WebCADGlobal.itemManager.currentWallGroup);
        if (!hasItemSelection && hasWallSelection) {
          marietta.webcad.WebCADGlobal.itemManager.unselectAllCurrents();
          marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
          return;
        }
        if (!hasItemSelection) {
          marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
        } else {
          if (prevItem instanceof marietta.webcad.item.Site) return;
          marietta.webcad.WebCADGlobal.itemManager.addItemToGroupObject(this, prevItem);
        }
        return;
      }
      // タブレット等では壁（マウス判定用透明壁）に touchstart が登録されておらず、
      // 壁のタップが部屋までバブリングして部屋が選択されてしまうため、
      // タップ位置が自部屋の壁であれば壁選択へ委譲する。
      // 複数選択モード中のタップは上の複数選択処理で部屋側が扱うため、ここには到達しない。
      if (!marietta.webcad.WebCADGlobal.userAgentManager.isPC
        && marietta.webcad.WebCADGlobal.layerGroup.itemEnabled
        && this instanceof marietta.webcad.item.Room) {
        const tappedWall: marietta.webcad.item.parts.Wall = this.wallObjList.find((wall: marietta.webcad.item.parts.Wall) => wall.isMouseTargetElement(e.target));
        if (tappedWall) {
          // 長押し（重なりリスト表示）は部屋タップ時と同様に有効のまま残し、指を離した時点でタイマーを解除する
          document.addEventListener('touchend', this.cancelLongPressOnTouchEnd, { once: true });
          tappedWall.onMouseDownMe(e);
          return;
        }
      }

      marietta.webcad.WebCADGlobal.itemManager.currentWallGroup = null;
      marietta.webcad.WebCADGlobal.itemManager.currentWall = null;
      this.previousPlace = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);

      // 無効状態判別
      if (this.itemInfo.id.indexOf('sit') > -1) {
        if (!marietta.webcad.WebCADGlobal.layerGroup.siteEnabled) {
          // カレントをなくす
          marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
          marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
          return;
        }
      } else if (!marietta.webcad.WebCADGlobal.layerGroup.itemEnabled) {
        // カレントをなくす
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
        return;
      }

      // カレントの設定
      e.preventDefault();

      // 既にカレントに定義されていたか否か
      const wasCurrentItem: boolean = Boolean(marietta.webcad.WebCADGlobal.itemManager.currentItem === this);

      // カレントに設定
      marietta.webcad.WebCADGlobal.itemManager.currentItem = this;

      const rect: DOMRect = this.spt.getBoundingClientRect();

      if (!this.isCapableOfMove()) return;

      // カレントが既に設定されていたか否か
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        // モバイル、タブレットの場合は、一度選択してから移動などを行える
        const self: MonicaObject = this;
        self.moveOnMouseMove = wasCurrentItem;
      }

      if (this instanceof marietta.webcad.item.Site && this.inputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
        return;
      }

      this.dragInitX = this.spt.mouseX * this.spt.scaleX;
      this.dragInitY = this.spt.mouseY * this.spt.scaleY;

      // ドラッグの開始
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.localDragPoint = new marietta.core.Point(e.pageX - rect.left, e.pageY - rect.top);
        document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
        document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
      } else {
        this.localDragPoint = new marietta.core.Point(e.clientX - rect.left, e.clientY - rect.top);
        document.addEventListener('mousemove', this.onMouseMoveMe);
        document.addEventListener('mouseup', this.onMouseUpMe);
      }

      // comment k.kubonaka
      // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
      // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
      const scope: MonicaObject = this;
      this.spt.onEnterFrame = (): void => {
        if (scope.moveMouseEvent != null) {
          scope.onMouseMoveHandler();
        }
      };

      // コピーされたフィッティング時にスナップ壁にフィッティングを作成します
      if (this instanceof marietta.webcad.item.Fitting) {
        if (this.snapWall == null) {
          // 壁への吸着
          this.snapToWall(false);
          this.wallPreviousPlace = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
          this.previousRotation = this.itemInfo.rotation;
          if (this.snapWall != null) {
            this.previousSnapWall = this.snapWall;
          }
        } else {
          this.wallPreviousPlace = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
          this.previousRotation = this.itemInfo.rotation;
          this.previousSnapWall = this.snapWall;
        }
      }

      // 子供を隠す
      this.hideChildren();
    }

    protected onMouseMoveHandler(): void {
      // iPadやスマホでは選択後に初めて移動となるため、初回のドラッグは無視
      if (this.moveOnMouseMove === false) return;

      // 一定距離を動いていなければ無視（建具の場合）
      if (this instanceof marietta.webcad.item.Fitting && !this.isFollowingMouse) {
        if (marietta.core.Point.distance(this.previousPlace, new marietta.core.Point(marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY)) < 5) {
          return;
        }
      }

      // var newPoint:marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);

      const x = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX;
      const y = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY;
      this.checkLongPress();
      this.itemInfo.x = x;
      this.itemInfo.y = y;
      this.updateTransforms();

      // Debugger.text(0, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX);
      // Debugger.text(1, this.dragInitX);

      // 壁への吸着
      this.snapToWall();

      this.snapToGrid();

      // アイテムを自分と同期させる
      if (marietta.webcad.WebCADGlobal.itemManager.itemController) {
        marietta.webcad.WebCADGlobal.itemManager.itemController.syncMeToTarget();
      }
    }

    /**
     * マウスが移動した
     */
    onMouseMoveMe = (e: MouseEvent & TouchEvent) => {
      e.preventDefault();
      this.moveMouseEvent = e;
      if (this instanceof marietta.webcad.item.PinText) {
        if ((e.target as HTMLElement).closest('foreignObject')) {
          return;
        } else {
          if (!(this instanceof marietta.webcad.item.PinPicture)) {
            this.isTextHide = true;
            this.textShowHide();
          }
        }
      }
      // pad スマホ用タッチ座標修正
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        if (e.touches.length >= 2) {
          this.onMouseUpMe(e);
          return;
        }

        e.preventDefault();
        Stage.refreshStageMouse(<any>e);
      }
      // ItemMoveの開始時に測定線を非表示にする
      const targetId = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id;
      const targetKey = targetId.substring(0, 3);
      if (targetKey === ITEM_MODE_KEY.MODE_ROOM_KEY || targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
        marietta.webcad.WebCADGlobal.itemManager.hideMeasureLine();
      }
    }

    /**
     * マウスがUPされた
     */
    onMouseUpMe = (e: MouseEvent & TouchEvent) => {
      // 長押しタイマー停止
      this.stopLongPress(false);
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        if (e.touches.length > 1) {
          return;
        }
      }

      const param: any = {};
      param.target = this;
      // シェアモードではアイテムの変更を行わせず、ダイアログ内のマスタ取得APIも呼ばないため表示しない
      if (this.moveMouseEvent === null && !this.isLongPress && !marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
        if (marietta.webcad.WebCADGlobal.isItemForQuotation(this.itemInfo.id)) {
          marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ItemChangeDialogStarts, false, false, true, true, param);
        } else if (this.itemInfo.id.indexOf('bem') > -1) {
          marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.TextureAndItemDialogStarts2D, false, true, true, true, param);
        }
      }

      e.preventDefault();
      this.spt.deleteEnterFrame();
      this.moveMouseEvent = null;

      // 一定距離を動いていなければ無視（建具の場合）
      if (marietta.core.Point.distance(this.previousPlace, new marietta.core.Point(marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY)) < 5 && !this.isFollowingMouse) {
        console.log('');
      } else {
        this.snapToGrid();
      }

      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchmove', this.onMouseMoveMe);
        document.removeEventListener('touchend', this.onMouseUpMe);
      } else {
        document.removeEventListener('mousemove', this.onMouseMoveMe);
        document.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('mouseup', this.onMouseUpMe);
      }
      ua = null;

      // 子供の移動
      this.moveChildren();
      // 子供の表示
      this.showChildren();

      // カレントにする前に呼んで、移動後の値を H 欄に出す
      marietta.webcad.WebCADGlobal.itemManager.onItemsMoved();

      // カレントの更新
      marietta.webcad.WebCADGlobal.itemManager.currentItem = this;

      // 親部屋を設定する
      this.setParentRoom();
      if (marietta.core.Point.distance(this.previousPlace, new marietta.core.Point(marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY)) > 5) {
        marietta.webcad.WebCADGlobal.quotationItemList.createData();
      }

      // 前にスナップした位置にフィッティングアイテムを配置します
      // this.snapToPreviosWallPosition();

      // 屋根であれば最前面へ移動
      if (this instanceof marietta.webcad.item.Roof) {
        marietta.webcad.WebCADGlobal.itemManager.moveTop(this);
      }

      marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
      if (marietta.core.Point.distance(this.previousPlace, new marietta.core.Point(this.itemInfo.x, this.itemInfo.y)) !== 0) {
        if (this.itemInfo.id.substring(0, 3) === 'rom' || this.itemInfo.id === 'fit01_01' || this.itemInfo.id === 'fit01_03' || this.itemInfo.id === 'fit02_01') {
          marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        } else if ((this.itemInfo.id.substring(0, 3) === 'col') && marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
        }
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
        // ライン測定を更新する
        marietta.webcad.WebCADGlobal.updateMeasureLine();
      }

    }

    /**
     * 長押しタイマー開始
     */
    private startLongPress() {
      this.longPressTime = window.setInterval(() => this.stopLongPress(true), 500);
    }

    /**
     * 長押し中のチェック
     */
    private checkLongPress() {
      if (this.longPressTime === null) return;
      const dis = marietta.core.Point.distance(this.previousPlace, new marietta.core.Point(marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY))
      // マウスの移動制限、超えたらタイマー停止
      const limitArea = 5;
      if (dis > limitArea) {
        this.stopLongPress(false);
      }
    }

    /**
     * 壁選択へ委譲したタップの touchend で長押しタイマーを解除する
     */
    private cancelLongPressOnTouchEnd = (): void => {
      this.stopLongPress(false);
    };

    /**
     * 長押しタイマー停止
     */
    private stopLongPress(isLongStop: boolean) {
      if (this.longPressTime === null) return;
      // 長押しのキャンセル
      window.clearTimeout(this.longPressTime);
      this.longPressTime = null;
      // 長押し処理以外で停止した場合は何もしない
      if (!isLongStop) return;
      this.isLongPress = true;
      marietta.webcad.WebCADGlobal.overlapItemList.showList();
    }

    /**
     * parentRoom を設定する有効なアイテムですか
     */
    canSetParentRoom(): boolean {
      if (this.itemInfo.id.indexOf('fur') > -1 || this.itemInfo.id.indexOf('equ') > -1 || this.itemInfo.id.indexOf('bem') > -1 || this.itemInfo.id.indexOf('col') > -1) {
        return true;
      }
      return false;
    }

    /**
     * 親部屋を設定する
     */
    setParentRoom() {
      if (this.canSetParentRoom()) {
        let point: marietta.core.Point;
        if (this.itemInfo.id.indexOf('fur') > -1 || this.itemInfo.id.indexOf('equ') > -1) {
          point = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
        } else if (this.itemInfo.id.indexOf('bem') > -1 || this.itemInfo.id.indexOf('col') > -1) {
          const dotList = this.itemInfo.dotList.map((d: marietta.webcad.collection.PointCollection) => d.clone());
          point = marietta.webcad.util.WebCADUtil.getPolygonCentroid(dotList);
        }
        if (point) {
          const room = marietta.webcad.util.WebCADUtil.getRoomAtPoint(point, this.itemInfo.floor);
          if (room) this.itemInfo.parentRoom = room;
        }
      }
    }

    /**
     *
     * @param e
     */
     onKeyDown = (e: KeyboardEvent) => {
       if (document.activeElement.tagName.toLowerCase() === 'input') return;
       if (!marietta.webcad.WebCADGlobal.itemManager.currentItem) return;
       if (marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id.substring(0, 3) !== 'fit') return;
       const textbox = document.getElementById('fittingGuideTextbox').firstChild;
       if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 8) {
         if (textbox !== document.activeElement) { (<HTMLInputElement>textbox).value = ''; }
         (<HTMLElement>document.getElementById('fittingGuideTextbox').firstChild).focus();
       }
     }

    /**
     * 子供を移動
     */
    moveChildren=(): void => { }

    /**
     * 子供を表示
     */
    showChildren=(): void => { }

    /**
     * 子供を隠す
     */
    hideChildren=(): void => { }

    /**
     * 子供の更新
     */
    updateChildren=(): void => { }

    /**
     * 子供の削除
     */
    removeChildren=(): void => { }

    changeType=(id: string) => { console.log(id); }

    /**
     * グリッドに吸い付く
     * */
    snapToGrid = () => {
      if (this.itemInfo.id.indexOf('fur') > -1 || this.itemInfo.id.indexOf('equ') > -1) return;
      const snapUnit = 1;
      this.itemInfo.x = Math.round(this.itemInfo.x / snapUnit) * snapUnit;
      this.itemInfo.y = Math.round(this.itemInfo.y / snapUnit) * snapUnit;
      this.updateTransforms();
    }

    // ----------------------------Follow Mouse--------------------------
    /**
     * マウス追従開始
     */
    startFollowMouse = () => {
      this.isFollowingMouse = true;

      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.addEventListener('touchmove', this.followMouse, { passive: false });
        document.addEventListener('touchend', this.stopFollowMouse, { passive: false });
      } else {
        if (this instanceof marietta.webcad.item.Stair) marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;
        document.addEventListener('mousemove', this.followMouse);
        if (marietta.webcad.WebCADGlobal.itemMenu._tempHideMenu !== '')marietta.webcad.WebCADGlobal.itemMenu.hideAll();
        // comment k.kubonaka
        // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
        // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
        const scope: MonicaObject = this;
        this.spt.onEnterFrame = (): void => {
          if (scope.moveMouseEvent != null) {
            scope.followMouseHandler();
          }
        };

        if (this.itemInfo.id.indexOf('rom') > -1) {
          this.spt.element.addEventListener('mouseup', this.stopFollowMouse);
        } else {
          document.addEventListener('mousedown', this.handleMouseDown);
        }

        // WEBCAD-1204対応 スクロール拡大縮小を無効にする
        marietta.webcad.WebCADGlobal.scrollerManager.scrollEnable = false;
      }
    }

    /**
    * マウスダウン
    */
    private handleMouseDown = (e: MouseEvent | TouchEvent = null) => {
      if (this instanceof marietta.webcad.item.Stair) marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
      this.stopFollowMouse(e);
    }

    private followMouseHandler(): void {
      if (this.spt == null) return;
      this.itemInfo.x = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX;
      this.itemInfo.y = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY;
      this.updateTransforms();

      // スナップ
      this.snapToGrid();

      // 壁への吸着
      this.snapToWall();

      // 子供の位置更新
      this.updateChildren();

      // 子供を隠す
      this.hideChildren();

      // アイテムを自分と同期させる
      if (marietta.webcad.WebCADGlobal.itemManager.itemController) {
        marietta.webcad.WebCADGlobal.itemManager.itemController.syncMeToTarget();
      }
    }

    /**
     * マウス追従
     */
    followMouse = (e: MouseEvent & TouchEvent) => {
      e.preventDefault();
      this.moveMouseEvent = e;
      const self: MonicaObject = this;
      // pad スマホ用タッチ座標修正
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        if (e.touches.length >= 2) {
          // self.deleteMe();
          self.onMouseUpMe(e);
          return;
        }

        e.preventDefault();
        Stage.refreshStageMouse(<any>e);
      }
    }

    /**
     * マウス追従終了
     */
    stopFollowMouse = (e: MouseEvent | TouchEvent = null) => {
      // WEBCAD-1204対応 ホイール拡大縮小を元に戻す
      marietta.webcad.WebCADGlobal.scrollerManager.scrollEnable = true;

      // ボタンが押されていたら無視
      if (e != null) {
        let target: Node = (e.target as HTMLElement).parentNode;
        while (target.parentNode) {
          target = target.parentNode;
          if (String(target.nodeName) === 'BUTTON') {
            return;
          }
        }

        e.preventDefault();
      }
      this.isFollowingMouse = false;

      // エラー防止
      if (this.spt != null && this.spt !== undefined) {
        this.spt.deleteEnterFrame();
      }

      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchmove', this.followMouse);
        document.removeEventListener('touchend', this.stopFollowMouse);
      } else {
        document.removeEventListener('mousemove', this.followMouse);
        if (this.itemInfo.id.indexOf('rom') > -1) {
          this.spt.element.removeEventListener('mouseup', this.stopFollowMouse);
        } else {
          document.removeEventListener('mousedown', this.stopFollowMouse);
          document.removeEventListener('mousedown', this.handleMouseDown);
        }
      }
      ua = null;
      // スナップ
      this.snapToGrid();

      // 壁への吸着
      this.snapToWall();

      // スナップ
      this.snapToGrid();

      // 基本アクションの設定
      this.initMe();

      // メニューから置いた UB は、置いた位置の天井高さを高さの初期値にする（カレントにする前に入れて H 欄に出す）
      marietta.webcad.util.UnitBathUtil.fitToCeiling(this);

      // カレントの設定
      marietta.webcad.WebCADGlobal.itemManager.currentItem = this;

      // 親部屋を設定する
      this.setParentRoom();
      marietta.webcad.WebCADGlobal.quotationItemList.createData();

      // 子供を隠す
      this.showChildren();

      // 前にスナップした位置にフィッティングアイテムを配置します
      if (!(this.itemInfo.id === 'fit01_01' || this.itemInfo.id === 'fit01_03' || this.itemInfo.id === 'fit02_01')) {
        // this.snapToPreviosWallPosition();
      }

      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      if (this.itemInfo.id === 'fit01_01' || this.itemInfo.id === 'fit01_03' || this.itemInfo.id === 'fit02_01') {
        marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
      }
      // ライン測定を更新する
      if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) marietta.webcad.WebCADGlobal.updateMeasureLine();
      if (marietta.webcad.WebCADGlobal.itemMenu._tempHideMenu !== '')marietta.webcad.WebCADGlobal.itemMenu.show(marietta.webcad.WebCADGlobal.itemMenu._tempHideMenu);
    }

    /**
     * 前にスナップした位置にフィッティングアイテムを配置します
     */
    snapToPreviosWallPosition() {
      if (this.itemInfo.id === 'fit01_01' || this.itemInfo.id === 'fit01_02' || this.itemInfo.id === 'fit01_03') {
        return;
      }
      if (this instanceof marietta.webcad.item.Fitting) {
        if (this.snapWall == null) {
          if (this.wallPreviousPlace === undefined) {
            if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null) {
              marietta.webcad.WebCADGlobal.itemManager.currentItem.deleteMe();
            }
            marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
            // 連続入力じゃない状態で生成に失敗したら選択モードに戻す
            if (!$(document.querySelector('#checkContinualInputOpening')).prop('checked')) {
              marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
            }
          } else {
            this.itemInfo.x = this.wallPreviousPlace.x;
            this.itemInfo.y = this.wallPreviousPlace.y;
            this.itemInfo.rotation = this.previousRotation;
            this.updateTransforms();
            this.snapWall = this.previousSnapWall;
            marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
          }
        } else {
          this.wallPreviousPlace = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
          this.previousRotation = this.itemInfo.rotation;
          this.previousSnapWall = this.snapWall;
        }
      }
    }

    /**
     * 回転
     * @param 回転角度（度数）
     */
    rotate(_angle: number) {
      let angle = _angle;
      // 自動回転アイテムは回転できないようにする
      if (marietta.webcad.WebCADGlobal.isAutoFacingItem(this.itemInfo.id)) {
        // 回転はできないアイテム
        angle = 0;
        this.itemInfo.rotation = angle;
        this.updateTransforms();
      } else {
        if (angle >= 360) angle %= 360;

        this.itemInfo.rotation = angle;
        this.updateTransforms();
      }
    }

    /**
     * サイズ変更(ホワイトアイテム以外用)
     * @param Number 幅
     * @param Number 高
     * @param Boolean ピクセル単位か否か
     * */
    changeSizeForNonWhiteItem(w: number, h: number, isPixUnit: Boolean = true) {
      const motoID = this.itemInfo.idthreed;
      this.itemInfo.idthreed = null;
      // サイズ変更
      this.changeSize(w, h, isPixUnit);
      this.itemInfo.idthreed = motoID;
    }

    /**
     * サイズ変更(ホワイトアイテム以外用)
     * @param Number 幅
     * @param Number 高
     * @param Boolean ピクセル単位か否か
     * ※分かりやすいよう関数を分けてありますが、サイズ変更(ホワイトアイテム以外用)と同じ内容
     * */
    changeSizeForInit(w: number, h: number, isPixUnit: Boolean = true) {
      this.changeSizeForNonWhiteItem(w, h, isPixUnit);
    }

    /**
     * サイズ変更
     * @param Number 幅
     * @param Number 高
     * @param Boolean ピクセル単位か否か
     * */
    changeSize(_w: number, _h: number, isPixUnit: Boolean = true, force:boolean = false) {
      let h = _h;
      let w = _w;

      // アイテム選択してあるものは、サイズ変更できないようにする
      if( force != true ){
        if (!this.itemInfo.isWhiteItem()) return;
      }

      // 自動回転アイテムはスケール保持
      if (marietta.webcad.WebCADGlobal.isAutoFacingItem(this.itemInfo.id)) {
        if (this.originalHeight === undefined || Number.isNaN(this.originalHeight)) return;
        if (this.originalWidth === undefined || Number.isNaN(this.originalWidth)) return;

        let diffW: number;
        let diffH: number;
        if (!isPixUnit) {
          // どっちが変更されたかをみて、もう片方を合わせる
          diffW = Math.abs(Math.max(w, this.itemInfo.widthmm) - Math.min(w, this.itemInfo.widthmm));
          diffH = Math.abs(Math.max(h, this.itemInfo.heightmm) - Math.min(h, this.itemInfo.heightmm));
          if (diffH < diffW) {
            h = (this.originalHeight / this.originalWidth) * w;
          } else {
            w = (this.originalWidth / this.originalHeight) * h;
          }

          this.itemInfo.widthmm = Math.round(w);
          this.itemInfo.heightmm = Math.round(h);
          // ピクセル単位
          w = Math.round(marietta.webcad.util.WebCADUtil.convertMMToPix(w));
          h = Math.round(marietta.webcad.util.WebCADUtil.convertMMToPix(h));
        } else {
          diffW = Math.abs(Math.max(w, this.itemInfo.width) - Math.min(w, this.itemInfo.width));
          diffH = Math.abs(Math.max(h, this.itemInfo.height) - Math.min(h, this.itemInfo.height));
          if (diffH < diffW) {
            h = (this.originalHeight / this.originalWidth) * w;
          } else {
            w = (this.originalWidth / this.originalHeight) * h;
          }

          this.itemInfo.widthmm = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(w));
          this.itemInfo.heightmm = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(h));
        }
      } else if (!isPixUnit) {
        this.itemInfo.widthmm = Math.round(w);
        this.itemInfo.heightmm = Math.round(h);
        // ピクセル単位。丸めは描画サイズの下限をかけたあとで行う
        w = marietta.webcad.util.WebCADUtil.convertMMToPix(w);
        h = marietta.webcad.util.WebCADUtil.convertMMToPix(h);
      } else {
        this.itemInfo.widthmm = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(w));
        this.itemInfo.heightmm = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(h));
      }

      this.itemInfo.width = Math.round(MonicaObject.floorDrawSizePix(w));
      this.itemInfo.height = Math.round(MonicaObject.floorDrawSizePix(h));

      const motoR: number = this.itemInfo.rotation;
      this.rotate(0);

      // 適用
      this.updateTransforms();

      // 回転を元に戻す
      this.rotate(motoR);

      // パネル更新
      marietta.webcad.WebCADGlobal.itemControlPanel.panelUpdate();
    }

    /**
     * 削除
     * */
    deleteMe(resolve:Function = null, continues: boolean = false) {
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.spt.element.removeEventListener('touchstart', this.onMouseDownMe);
      } else {
        document.removeEventListener('mousedown', this.onMouseDownMe);
      }
      if( this.spt.onEnterFrame ){
        delete this.spt.onEnterFrame;
      }

      if (this.spt.parent != null) {
        this.spt.parent.removeChild(this.spt);
      }
      this.spt = null;

      // 子供の削除
      this.removeChildren();

      // ライン測定を更新する
      if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) marietta.webcad.WebCADGlobal.updateMeasureLine();

      if (!continues) marietta.webcad.WebCADGlobal.quotationItemList.createData();

      // アイテムコントローラを非表示
      if (!continues) marietta.webcad.WebCADGlobal.itemManager.currentItem = null;

      if (resolve) resolve();
      // ピンなら配列に入れる
      if (this instanceof marietta.webcad.item.PinPicture && this.itemInfo.pin_id) {
        marietta.WebCADGlobal.webcad2Dmanager.deletePins.push(this.itemInfo.pin_id);
      }
    }

    /**
     * 移動 XY
     */
    move(x: number, y: number) {
      this.itemInfo.x = x;
      this.itemInfo.y = y;
      this.updateTransforms();
    }

    /**
    * 移動X
    */
    moveX(x: number) {
      this.itemInfo.x = x;
      this.updateTransforms();
    }

    /**
    * 移動Y
    */
    moveY(y: number) {
      this.itemInfo.y = y;
      this.updateTransforms();
    }

    /**
     * 左右反転
     */
    reverse() {
      // this.spt.scaleX *= -1;
      this.spt.isReverse = !this.spt.isReverse;

      // 情報保持
      this.itemInfo.lr = this.spt.isReverse;// Boolean(this.spt.scaleX < 0);

      this.updateTransforms();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      if (Number.isNaN(this.spt.scaleX)) this.spt.scaleX = 1;
      if (Number.isNaN(this.spt.scaleY)) this.spt.scaleY = 1;

      // 敷地、部屋の場合は無視
      if (!this.itemInfo.dotList || this.itemInfo.dotList.length < 1) {
        this.spt.width = Math.abs(this.itemInfo.width);
        this.spt.height = this.itemInfo.height;
      }
      this.spt.rotation = this.itemInfo.rotation;
      this.spt.update();
    }

    /**
     * 現行のTransform
     */
    getCurrentTransform(): string {
      let retTransform: string = '';
      retTransform += `translate( ${this.itemInfo.x}, ${this.itemInfo.y} ) `;
      retTransform += `rotate( ${this.itemInfo.rotation} ) `;
      if (Number.isNaN(this.itemInfo.width / this.originalWidth)) {
        retTransform += 'scale( 1, 1 ) ';
      } else {
        retTransform += `scale( ${this.itemInfo.width / this.originalWidth}, ${this.itemInfo.height / this.originalHeight} ) `;
      }

      return retTransform;
    }

    /**
     * ビューオブジェクトの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt?.element;
    }

    /**
     * 壁への吸着
     */
    snapToWall=() => {
      if (this.itemInfo.id === 'fit01_01' || this.itemInfo.id === 'fit01_02' || this.itemInfo.id === 'fit01_03') {
        return;
      }
      if (marietta.webcad.WebCADGlobal.itemManager.itemController !== undefined &&
        (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerWithGuide || marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerColumnWithGuide)) {
        const dist = marietta.webcad.WebCADGlobal.itemManager.itemController.calculateDistance();
        if (dist && dist.top && dist.top.distance != null && (marietta.webcad.util.WebCADUtil.convertPixToMM(dist.top.distance) <= 100)) {
          marietta.webcad.WebCADGlobal.itemManager.itemController.moveItemWithInput(0, 'Top');
        }
        if (dist && dist.right && dist.right.distance != null && (marietta.webcad.util.WebCADUtil.convertPixToMM(dist.right.distance) <= 100)) {
          marietta.webcad.WebCADGlobal.itemManager.itemController.moveItemWithInput(0, 'Right');
        }
        if (dist && dist.bottom && dist.bottom.distance != null && (marietta.webcad.util.WebCADUtil.convertPixToMM(dist.bottom.distance) <= 100)) {
          marietta.webcad.WebCADGlobal.itemManager.itemController.moveItemWithInput(0, 'Bottom');
        }
        if (dist && dist.left && dist.left.distance != null && (marietta.webcad.util.WebCADUtil.convertPixToMM(dist.left.distance) <= 100)) {
          marietta.webcad.WebCADGlobal.itemManager.itemController.moveItemWithInput(0, 'Left');
        }
      } else if (this.itemInfo.is_wall_item) {
        const closestWall = this.getClosestWall(new marietta.core.Point(this.itemInfo.x, this.itemInfo.y));
        if (!closestWall || !closestWall.wall) return;
        const parentRoomBound = closestWall.wall.parentObj.spt.element.getBoundingClientRect();
        const minRoomBound: marietta.core.Point = new marietta.core.Point(parentRoomBound.left, parentRoomBound.top);
        const maxRoomBound: marietta.core.Point = new marietta.core.Point(parentRoomBound.left + parentRoomBound.width, parentRoomBound.top + parentRoomBound.height);
        const parentRoomCenter: marietta.core.Point = new marietta.core.Point((minRoomBound.x + maxRoomBound.x) / 2, (minRoomBound.y + maxRoomBound.y) / 2);
        const wallCenter: marietta.core.Point = marietta.core.Point.interpolate(closestWall.line.p1, closestWall.line.p2, 0.5);

        // 2点間の角度
        const r = Math.atan2((parentRoomCenter.y - wallCenter.y), (parentRoomCenter.x - wallCenter.x));

        let deg = (((r * 180) / Math.PI) + 270) % 360;
        deg = Math.abs((deg) - (closestWall.wall.angle + 180) % 360) < 90
          ? (closestWall.wall as marietta.webcad.item.parts.Wall).angle
          : (closestWall.wall as marietta.webcad.item.parts.Wall).angle - 180;

        if (deg < 0) deg += 360;
        const degDiff: number = Math.abs(Math.max(this.itemInfo.rotation, deg) - Math.min(this.itemInfo.rotation, deg));
        // 配置後でさらに、180度回転するようなものは回転しない
        if (!this.isFollowingMouse && degDiff % 180 === 0) {
          // 回転の適用はしない
        } else {
          const newDeg = deg < 180 ? deg + 180 : deg - 180;
          // 角度が180度間違っているので調整
          deg = Math.abs(this.itemInfo.rotation - deg) < Math.abs(this.itemInfo.rotation - (newDeg)) ? deg : newDeg;
          this.itemInfo.rotation = deg;
        }

        this.itemInfo.x = closestWall.point.x;
        this.itemInfo.y = closestWall.point.y;
        this.updateTransforms();
      }
    }

    getClosestWall(p: marietta.core.Point = null) {
      const tarLayer: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.itemInfo.floor);
      let newPoint:Point = new Point(tarLayer.spt.mouseX, tarLayer.spt.mouseY);
      if (p != null) {
        newPoint = new Point(Math.round(p.x), Math.round(p.y));
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
      }
      const { wallList } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
      // 近い壁を探す
      const closestWalls :{ wall:marietta.webcad.item.parts.Wall, line: {p1:Point, p2:Point}, distance: number, crossPoint: Point }[] = [];
      let crossPoint: marietta.core.Point;
      for (let i: number = 0; i < wallList.length; i += 1) {
        const poly = marietta.webcad.util.WebCADUtil.createPolygonLine([wallList[i].globalStartDot, wallList[i].globalEndDot], marietta.webcad.WebCADGlobal.WALL_WIDTH, true);
        if (poly.length > 3) {
          const line1 = { p1: poly[0], p2: poly[1] };
          const line2 = { p1: poly[2], p2: poly[3] };
          const crossPoint1 = marietta.webcad.util.WebCADUtil.calculateCrossPoint(line1.p1, line1.p2, newPoint);
          const crossPoint2 = marietta.webcad.util.WebCADUtil.calculateCrossPoint(line2.p1, line2.p2, newPoint);
          if (crossPoint1 && crossPoint2) {
            const distance1 = marietta.core.Point.distance(crossPoint1, newPoint);
            const distance2 = marietta.core.Point.distance(crossPoint2, newPoint);
            if (distance1 <= distance2 && distance1 <= 20) {
              closestWalls.push({ wall: wallList[i], line: line1, distance: distance1, crossPoint: crossPoint1 });
            } else if (distance2 <= distance1 && distance2 <= 20) {
              closestWalls.push({ wall: wallList[i], line: line2, distance: distance2, crossPoint: crossPoint2 });
            }
          }
        }
      }
      if (closestWalls.length < 1) return null;
      let closestWall: marietta.webcad.item.parts.Wall;
      let minDistance = NaN;
      let line:{p1:Point, p2:Point};
      for (let i = 0; i < closestWalls.length; i += 1) {
        if (Number.isNaN(minDistance) || closestWalls[i].distance < minDistance) {
          minDistance = closestWalls[i].distance;
          closestWall = closestWalls[i].wall;
          crossPoint = closestWalls[i].crossPoint;
          line = closestWalls[i].line;
        }
      }
      return { wall: closestWall, point: crossPoint, line };
    }

    /**
     * 前回の配置場所の保持
     */
    saveCurrentPosition(): void {
      this.previousPlace = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
    }

    /**
     * ロック可視化状態の変更
     */
    changeLockView(value: boolean) {
      if (value) {
        this.spt.alpha = 0.3;
      } else {
        this.spt.alpha = 1;
      }
    }

    /**
     * Rect情報の取得
     * @return marietta.core.Rectangle
     */
    getBoundRect(): marietta.core.Rectangle {
      let bound: marietta.core.Rectangle;

      if (this.itemInfo.dotList && this.itemInfo.dotList.length) {
        let minX: number;
        let minY: number;
        let maxX: number;
        let maxY: number;
        let tarX: number;
        let tarY: number;

        for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
          tarX = this.itemInfo.x + this.itemInfo.dotList[i].x;
          tarY = this.itemInfo.y + this.itemInfo.dotList[i].y;
          if (minX === undefined || minX > tarX) minX = tarX;
          if (minY === undefined || minY > tarY) minY = tarY;
          if (maxX === undefined || maxX < tarX) maxX = tarX;
          if (maxY === undefined || maxY < tarY) maxY = tarY;
        }
        bound = new marietta.core.Rectangle(minX, minY, maxX - minX, maxY - minY);
      } else {
        const boundRect = this.viewObj.getBoundingClientRect();
        bound = new marietta.core.Rectangle(this.itemInfo.x - boundRect.width / marietta.webcad.WebCADGlobal.scaleSize / 2,
          this.itemInfo.y - boundRect.height / marietta.webcad.WebCADGlobal.scaleSize / 2,
          boundRect.width / marietta.webcad.WebCADGlobal.scaleSize,
          boundRect.height / marietta.webcad.WebCADGlobal.scaleSize);
      }

      return bound;
    }

    /**
     * ドラッグ可能か
     */
    public isCapableOfMove(): boolean {
      if (!marietta.webcad.WebCADGlobal.shareModeManager.canOperateModel) return false;
      if (this.itemInfo.lock) return false;
      return true;
    }

    /**
     * 回転可能か
     */
    public isCapableOfRotate(): boolean {
      if (!marietta.webcad.WebCADGlobal.shareModeManager.canOperateModel) return false;
      if (this.itemInfo.lock) return false;
      return true;
    }

    /**
     * リサイズ可能か
     */
    public isCapableOfResize(): boolean {
      if (!marietta.webcad.WebCADGlobal.shareModeManager.canOperateModel) return false;
      if (this.itemInfo.lock) return false;
      return true;
    }

    /**
     * 削除可能か
     */
    public isCapableOfDelete(): boolean {
      if (!marietta.webcad.WebCADGlobal.shareModeManager.canOperateModel) return false;
      if (this.itemInfo.lock) return false;
      return true;
    }

    /**
     * 入替可能な建具か否か
     */
    public isCapableOfSwitch =(): boolean => true

    /**
     * 反転も可能か
     */
    public isCapableOfReverse(): boolean {
      if (!marietta.webcad.WebCADGlobal.shareModeManager.canOperateModel) return false;
      if (this.itemInfo.lock) return false;
      return true;
    }

    /**
     * 線の色を変更する
     */
    public changeStrokeColor=(): void => {
    }

    /**
     * 領域情報取得
     * @return 領域情報
     */
    public getBoundingClientRect(): DOMRect {
      return this.viewObj.getBoundingClientRect();
    }

    /**
     * フリーテキストアイテムを確認してください
     * @return boolean
     */
    public isFreeTextItem(): boolean {
      if (this.itemInfo.id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${FREETEXT_ITEMCODE}`) > -1) {
        return true;
      }
      return false;
    }

    /**
     * パイント テキスト アイテムをチェックするかどうか
     * @return boolean
     */
    public isPinTextItem(): boolean {
      for (let i = 0; i < marietta.webcad.WebCADGlobal.pinTextCategory.length; i += 1) {
        if (this.itemInfo.id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${marietta.webcad.WebCADGlobal.pinTextCategory[i].item_code}`) > -1) {
          return true;
        }
      }
      return false;
    }

    /**
     * パイント テキスト アイテムをチェックするかどうか
     * @return boolean
     */
    public isPinPictureItem(): boolean {
      for (let i = 0; i < marietta.webcad.WebCADGlobal.pinPictureCategory.length; i += 1) {
        if (this.itemInfo.id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${marietta.webcad.WebCADGlobal.pinPictureCategory[i].item_code}`) > -1) {
          return true;
        }
      }
      return false;
    }

    /**
     * パノラマ アイテムをチェックするかどうか
     * @return boolean
     */
    public isPinPanoramaItem(): boolean {
      for (let i = 0; i < marietta.webcad.WebCADGlobal.pinPanoramaCategory.length; i += 1) {
        if (this.itemInfo.id.indexOf(`${ITEM_MODE_KEY.MODE_FREETEXT_KEY}${marietta.webcad.WebCADGlobal.pinPanoramaCategory[i].item_code}`) > -1) {
          return true;
        }
      }
      return false;
    }

    /**
     * 頂点の変換
     */
    // eslint-disable-next-line class-methods-use-this
    public convertDots() {
      // Roomでオーバーライド
    }

    /** パノラマ画像を別ビューで表示 */
    public panoramaView() {
      // PinPanoramaでオーバーライド
    }

    updateItemWithInput(newDistance: number, index: number): void{};

    /**
     * エンドアイテムに設定する
     */
    public setToEndItem( info:MasterItemCollection ): boolean {
      this.itemInfo.end_item_info = info;
      if( info == null ) return;

      //サイズの適用
      this.itemInfo.idthreed = info.symbol_3d_code;
      if( this instanceof Fitting){
        this.changeSize( info.item_width, 0, false );
        this.itemInfo.fitting_height = info.item_height;
      }else {
        let depth = info.item_depth > 0 ? info.item_depth : marietta.webcad.Constants.DEFAULT_MINIMUM_DEPTH;
        this.changeSize( info.item_width, depth, false, true );
      }

      return;
    }

    /**
     * 2Dで高さ・設置高さを編集できるアイテムか
     */
    public isHeightEditableItem(): boolean {
      return marietta.webcad.WebCADGlobal.isHeightEditableItem(this.itemInfo.id);
    }

    /**
     * 幅・奥行の数値入力の下限(mm)。住設・家具だけ 1mm まで下げられる
     */
    public getMinPlanSizeMM(): number {
      return this.isHeightEditableItem() ? MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM : MIN_ITEM_PLAN_SIZE_MM;
    }

    /**
     * 正の描画サイズ(px)を最低 1px にする。mm の値（widthmm/heightmm）は変えない
     */
    public static floorDrawSizePix(pix: number): number {
      return pix > 0 && pix < MIN_DRAW_SIZE_PIX ? MIN_DRAW_SIZE_PIX : pix;
    }

}
